import React from "react";
import QueryFiltering from "../../containers/QueryFiltering";
import { PanelRow, Label, TextInput, CheckBox, RadioGroup, Radio } from "@backslashbuild/pp-ui";

function PayslipsFilter() {
  return (
    <QueryFiltering
      searchStringKey="search"
      getTagsFromState={(state) => {
        const tags = [];
        if (state.hasErrors === "yes") tags.push({ key: "errors", value: "Only" });
        if (state.hasErrors === "no") tags.push({ key: "errors", value: "Exclude" });
        if (state.hasWarnings === "yes") tags.push({ key: "warnings", value: "Only" });
        if (state.hasWarnings === "no") tags.push({ key: "warnings", value: "Exclude" });
        return tags;
      }}
      getNextStateFromDeleteTag={(state, key) => {
        if (key === "errors") return { ...state, hasErrors: undefined };
        if (key === "warnings") return { ...state, hasWarnings: undefined };
        return state;
      }}
      renderForm={(state, setState) => (
        <>
          <PanelRow>
            <Label label="Employee">
              <TextInput
                value={state.search}
                onChange={(e) => setState({ ...state, name: e.target.value })}
              />
            </Label>
          </PanelRow>
          <PanelRow>
            <Label label="Has Errors">
              <RadioGroup
                value={state.hasErrors}
                onChange={(e) => setState({ ...state, hasErrors: e.target.value })}
              >
                <Radio value="" label="Any" />
                <Radio value="yes" label="Yes" />
                <Radio value="no" label="No" />
              </RadioGroup>
            </Label>
          </PanelRow>
          <PanelRow>
            <Label label="Has Warnings">
              <RadioGroup
                value={state.hasWarnings}
                onChange={(e) => setState({ ...state, hasWarnings: e.target.value })}
              >
                <Radio value="" label="Any" />
                <Radio value="yes" label="Yes" />
                <Radio value="no" label="No" />
              </RadioGroup>
            </Label>
          </PanelRow>
        </>
      )}
    />
  );
}

export default PayslipsFilter;
